<template>
  <div v-if="legendOpen" class="absolute bottom-52 right-16 z-20">
    <card>
      <s-h2 class="mb-10">Map Legend</s-h2>
      <div class="flex mb-8" v-for="(item, i) in legendData" :key="i">
        <div class="h-6 w-6 mr-4">
          <img :src="item.icon">
        </div>
        <SH6 class="w-60 text-grey-dark">{{ item.title }}</SH6>
      </div>
    </card>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { emitter } from '@/common/utils/emitter';

import BlueBlack from '@/assets/icons/default-l-00b7ff.svg';
import GreenBlack from '@/assets/icons/default-l-8dc114.svg';
import BlueStar from '@/assets/icons/star-l-00b7ff.svg';
import GreenStar from '@/assets/icons/star-l-8dc114.svg';



import Card from '../../atoms/card.vue';
import SH2 from '../../atoms/s-h2.vue';
import SH6 from '../../atoms/s-h6.vue';

export default {
  components: {
    Card,
    SH2,
    SH6
  },
  setup() {


    const legendData = ref([
      {
        icon: BlueBlack,
        title: 'Accepts Paint and other Household Hazardous Waste (HHW)',
      },
      {
        icon: GreenBlack,
        title: 'Accepts Paint Only',
      },
      {
        icon: BlueStar,
        title: 'Accepts Paint and other HWW; also has a Reuse Program',
      },
      {
        icon: GreenStar,
        title: 'Accepts Paint only; also has a Reuse Program',
      },
    ]);

    const legendOpen = ref(false);

    onMounted(async () => {
      emitter.on('clicked:legend', (event) => {
        legendOpen.value = !legendOpen.value;
      });
    });

    onBeforeUnmount(() => {
      emitter.off('clicked:legend');
    });

    return { legendOpen, legendData };
  },
};
</script>
